<template>
  <v-container grid-list-md class="text-center">
    <v-layout row wrap>
      <v-flex md12 pa-2>
        <v-card>
          <v-img height="300px" :src="getContact.firstBannerImage"></v-img>
        </v-card>
      </v-flex>
      <v-flex 1 xs12 pa-2>
        <v-flex>
          <v-card-text class="display-1 font-weight-bold"
            >¿Tienes algún problema? Escríbenos</v-card-text
          >
          <div
            style="width: 6%; height: 3px;margin: 10px auto;background:#0D47A1;border-bottom: 1px solid black;"
          ></div>
        </v-flex>
      </v-flex>
      <v-flex xs12 pa-2>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-card-text>
                <v-text-field
                  v-model="userName"
                  label="Nombre"
                
                  prepend-icon="person"
                  :rules="[form.required]"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="email"
                  label="E-mail"
                  prepend-icon="email"
                  :rules="[form.required, form.email]"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-text>
                <v-select
                 
                  :items="items"
                  v-bind="type"
                  label="Seleccionar"
                ></v-select>
              </v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="phone"
                  label="Teléfono"
                  mask="phone"
                  prepend-icon="phone"
                  :rules="[form.required]"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-text>
                <v-textarea
                  v-model="message"
                  label="Mensaje"
                  prepend-icon="edit"
                  placeholder="Por favor describa su solicitud..."
                  rows="3"
                  :rules="[form.required]"
                  required
                ></v-textarea>
              </v-card-text>
              <v-btn @click="submit" large color="primary">
                <span>Enviar mensaje</span>
                <v-icon right size="15">send</v-icon>
              </v-btn>
            </v-form>

            <v-snackbar
              v-model="snackbar"
              :multi-line="mode === 'multi-line'"
              timeout="6000"
              :vertical="mode === 'vertical'"
            >
              {{ text }}
              <v-btn dark text @click="snackbar = false">Cerrar</v-btn>
            </v-snackbar>
          </v-flex>
          <v-flex xs12 md6>
            <v-card-text class="text-xs-left">
              <h3 class="headline mb-0">Nos gusta escucharte!</h3>
            </v-card-text>
            <v-card-text class="text-xs-left">
              <p>
                Nuestra promesa de servicio para nuestros clientes es ofrecerles
                un servicio de primera cumpliendo con todos estandares de
                calidad por eso contamos con nuestro personal de servicio
                cliente a disposición 24 horas los 7 días de la semana para
                cualquier inquietud.
              </p>
            </v-card-text>
            <v-card-text class="text-xs-left">
              <p class="headline mb-0">Información de contacto</p>
            </v-card-text>
            <v-card-text class="text-xs-left">
              <h3 class="title">Dirección</h3>
              <span class="grey--text">{{ getContact.info.address }}</span>
            </v-card-text>
            <v-card-text class="text-xs-left">
              <h3 class="title">Teléfono</h3>
              <span class="grey--text">(809)584-7676</span>
            </v-card-text>
            <v-card-text class="text-xs-left">
              <h3 class="title">Email</h3>
              <span class="grey--text">{{ getContact.info.email }}</span>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pa-2>
        <v-flex>
          <v-card-text class="display-1 font-weight-bold"
            >Puntos de servicio</v-card-text
          >
          <div
            style="width: 6%; height: 3px;margin: 10px auto;background:#0D47A1;border-bottom: 1px solid black;"
          ></div>
        </v-flex>
      </v-flex>
      <v-flex xs12 pa-2>
        <GmapMap
          :center="{ lat: 19.3785872, lng: -69.863065 }"
          :zoom="12"
          map-type-id="roadmap"
          style="width: 100%; height: 400px"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            :draggable="true"
            @click="center = m.position"
          />
        </GmapMap>
      </v-flex>
      <v-flex xs12 pa-2>
        <subscribe-container></subscribe-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { formatPhone } from "../../filters";

import SubscribeContainer from "../../components/shared/Subscribe-Container";

export default {
  name: "Support",
  components: {
    SubscribeContainer,
  },
  filters: {
    date(timestamp) {
      return formatDate(timestamp);
    },
    phone(number) {
      return formatPhone(number);
    },
  },
  data: () => ({
    form: {
      valid: false,
      required: (v) => !!v || "Este campo es requerido",
      email: (v) => /.+@.+/.test(v) || "El correo electrónico debe ser válido",
    },
    markers: [
      {
        title: "NAGUA",
        position: {
          lat: 19.3782268,
          lng: -69.8526621,
        },
        description: "Sucursal Nagua",
      },
      {
        title: "EL FACTOR",
        position: {
          lat: 19.3158207,
          lng: -69.8949767,
        },
        description: "Sucursal El Factor",
      },
      {
        title: "MATANCITAS",
        position: {
          lat: 19.3540834,
          lng: -69.8345005,
        },
        description: "Sucursal Matancitas",
      },
    ],
    email: null,
    phone: null,
    message: null,
    items: ["Reporte de avería", "Solicitud de información", "Pregunta", "Sugerencia"],
    userName: null,
    type: null,
    snackbar: false,
    color: "",
    mode: "",
    text: "Su mensaje ha sido enviado!",
  }),

  created() {
    this.loadContact();
  },
  computed: {
    ...mapState(["contact"]),
    getContact() {
      return this.contact;
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.makeContactRequest({
          email: this.email,
          phone: this.phone,
          message: this.message,
          userName: this.userName,
          type: this.type,
        }).then(() => {
          this.$refs.form.reset();
          this.snackbar = true;
        });
      }
    },
    ...mapActions(["loadContact", "makeContactRequest"]),
  },
};
</script>
<style scoped>
.shadow {
  text-shadow: 0 0 10px #424242, 0 0 15px #e0e0e0;
}
</style>
